import { Badge } from '@/components/ui/Badge'
import { outlookFolderName } from '@/features/order-confirmation/inbox/outlookFolder'
import { OutlookFolderLabel } from '@/features/order-confirmation/inbox/OutlookFolderLabel'

export function OutlookFolderBadge({
  folder,
  className,
}: {
  folder: string | null | undefined
  className?: string
}) {
  if (!outlookFolderName(folder)) return null

  return (
    <Badge tone="neutral" className={className}>
      <OutlookFolderLabel folder={folder} />
    </Badge>
  )
}
